import { useGate } from 'statsig-react';

export interface UseBundleGate {
  bundleEnabled: boolean;
  bundleUs: boolean;
  bundleInternational: boolean;
}

// TODO: GROW-1620 Productize Bundle
const useBundleGate = (): UseBundleGate => {
  const bundleUs = useGate('bundle_us').value;
  const bundleInternational = useGate('bundle_international').value;

  return {
    bundleEnabled: bundleUs || bundleInternational,
    bundleUs,
    bundleInternational,
  };
};

export default useBundleGate;
